import React from 'react'
import "./NoteItem.css"

import useModal from '../../../hooks/useModal'
import { useNavigate } from 'react-router-dom'
import { INoteFolder } from '../../../types/interfaces'
interface NoteItemProps{
  title: string,
  description: string,
  folderData: INoteFolder | undefined,
  content:string
  date: Date | string,
  deleteCallback: ((filterKey: number) => void),
  id:number
}
export default function NoteItem({id,title,content,description,date,folderData,deleteCallback}:NoteItemProps) {
  const [isOpen, toggleModal] = useModal()
  const navigate = useNavigate()
  return (
    <>
      <div id={`${id}`} className={`Note-Item ${folderData?.colour||"Default"}`}>
        <h3>{title}</h3>
        <b className='Note-Date'>{new Date(date).toLocaleDateString("en-us",{dateStyle:"medium"})}</b>
        <button className='Info-Btn' onClick={() => navigate(`/notes/${title}`)}>More Info</button>
        <button className='Delete-Btn' onClick={()=>deleteCallback(id)}>Delete</button>
        <button className='Edit-Btn' onClick={() => navigate(`/notes/edit/${title}`,{state:{id,title,description,date,folderData,content}})}>Edit</button>
        <p className='Note-Info'>{description}</p>
        <p className='Note-Folder'><b>Folder:</b><br />{folderData?.title}</p>
      </div>
    </>
    
  )
}
